import { marked } from 'marked'

// Make markdown links open in a new tab everywhere we render marked content.
marked.use({
  renderer: {
    link(href, title, text) {
      const t = title ? ` title="${title}"` : ''
      const safeHref = href || '#'
      return `<a href="${safeHref}" target="_blank" rel="noopener noreferrer"${t}>${text}</a>`
    },
  },
})

export { marked }


